/**
 * Meter archive post reads and show the paywall client-side.
 *
 * Anonymous visitors all get the same cached page. Archive posts include the
 * paywall markup in a <template>, which replaces the article content once the
 * free reads are used up.
 * Keep in sync with Mediapool\Restrict_Content.
 */

import { onReady, getCookie, setCookie } from './utils.js';

const READS_COOKIE = 'mar';
const FREE_READS = 3;
const COOKIE_DAYS = 10 * 365;

const showPaywall = () => {
	const template = document.getElementById( 'paywall-template' );
	const content = document.querySelector( '.c-article-content' );
	if ( ! template || ! content ) {
		return;
	}

	content.replaceChildren( template.content.cloneNode( true ) );
};

const meterRead = () => {
	const restrictedAfter = window.restricted_after || 0;
	if ( ! restrictedAfter || Date.now() / 1000 < restrictedAfter ) {
		return;
	}

	if ( document.body.classList.contains( 'logged-in' ) ) {
		return;
	}

	const reads = ( parseInt( getCookie( READS_COOKIE ), 10 ) || 0 ) + 1;
	setCookie( READS_COOKIE, reads, COOKIE_DAYS );

	if ( reads > FREE_READS ) {
		showPaywall();
	}
};

// The script is loaded in the footer, so the article is usually parsed already.
// Running right away keeps the article from flashing before the paywall.
onReady( meterRead );
